import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { BaseService } from 'src/app/system-common/services/base.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PolicyDetailsService } from '../services/policydetails.service';
import { PremiumDueSearchHandler } from './premium-due-search.handler';

@Component({
  selector: 'sym-premium-due-search',
  templateUrl: './premium-due-search.component.html',
  styleUrls: ['./premium-due-search.component.scss'],
})
export class PremiumDueSearchComponent extends PremiumDueSearchHandler implements OnInit {
  constructor(
    public service: PolicyDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
